module.exports = __webpack_public_path__ + "img/clickToDownload.7c9e3c30.svg";